/**************************************************
 * Nombre:       Formulario_Deposito_Captura
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {WALLETS} from "../../Constantes";
import Tarjeta_Cripto from "../Tarjetas/Tarjeta_Cripto";
import IngresoImagenCropCustom from "../../Modulo_formularios/Componentes/IngresoImagenCropCustom";

const Formulario_Deposito_Captura = ({...props}) => {

    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'center'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography sx={{textAlign: 'center'}}>Deposita en valor en la Wallet de tu eleccion y sube una
                        captura de
                        pantalla</Typography>
                </Grid>

                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}
                    spacing={4}
                    sx={{px: 2}}
                >

                    {WALLETS.map((item, i) => (


                        <Grid container size={{xs: 12, sm: 12, md: 6}} sx={{justifyContent: 'flex-start'}}>
                            <Tarjeta_Cripto item={item}/>
                        </Grid>

                    ))}

                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 2}}>
                    <Typography sx={{fontWeight: 600}}>Suba la Captura de Pantalla</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <IngresoImagenCropCustom dato={'img'} {...props}/>
                </Grid>

            </Grid>

        </form>

    )

}
export default Formulario_Deposito_Captura